<toaster-container [toasterconfig]="toasterconfig"></toaster-container>
<div class="app-body lotas">
    <main class="login d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <div class="card-group">
                        <div class="card p-4">
                            <div class="card-body">
                                <div class="text-center">
                                    <h3>ロータス・リアルタイム実績管理システム ({{appVersion}})</h3>
                                </div>

                                <form [formGroup]="form" (keyup.enter)="form.valid && login(form.value)" class="mt-3">
                                    <div class="input-group mb-1" [ngClass]="{'has-danger': formHelper.hasErrorTooltip(form, username,'username')}" tooltip="ユーザー名は3文字以上にして下さい" triggers="" #username="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="username" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'username')}" placeholder="ユーザー名">
                                    </div>
                                    <div class="input-group mb-2" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,password,'password')}" tooltip="パスワードを入力して下さい。" triggers="" #password="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-lock"></i></span>
                                        </div>
                                        <input type="password" class="form-control" formControlName="password" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password')}" placeholder="パスワード">
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="login(form.value)">ログイン</button>
                                        </div>
                                    </div>
                                </form>

                                <div class="row mt-2">
                                    <div class="col-12">
                                        パスワードのリセット依頼は<a [routerLink]="['/reset-password']">こちらで</a>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-12">
                                        使い方: <a [routerLink]="['/manual/member']">同友用マニュアル</a>
                                        ／ <a [routerLink]="['/manual/partner']">提携先用マニュアル</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
